<template>
  <v-form @submit="loginAction" onSubmit="return false;">
    <h1 class="mb-4">
      {{ $t("login.logInVerb") }}
    </h1>
    <v-text-field
      v-model="username"
      class="rounded-lg login-input-text"
      :label="$t('login.usernameOrEmail')"
      single-line
      dense
      color="accentElement"
      :rules="[() => !!username || $t('forms.thisFieldIsRequired')]"
      outlined
      :disabled="getInProgress"
    >
      <template v-slot:append-outer>
        <div class="error-append">
          <img v-if="errors" src="@/assets/warning.svg" />
        </div>
      </template>
    </v-text-field>
    <v-text-field
      v-model="password"
      class="rounded-lg login-input-text"
      :label="$t('login.password')"
      single-line
      dense
      :counter="MAX_PASSWORD_LENGTH"
      :type="showPassword ? 'text' : 'password'"
      :maxlength="MAX_PASSWORD_LENGTH"
      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      @click:append="showPassword = !showPassword"
      :rules="[rules.required]"
      :error-messages="errors"
      outlined
      :disabled="getInProgress"
    >
      <template v-slot:append-outer>
        <div class="error-append">
          <img v-if="errors" src="@/assets/warning.svg" />
        </div>
      </template>
    </v-text-field>
    <v-btn
      :disabled="getInProgress"
      :loading="getInProgress"
      color="primary"
      block
      type="submit"
      >{{ $t("login.logInVerb") }}</v-btn
    >
  </v-form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { MAX_PASSWORD_LENGTH } from "@/const";
import logout from "@/logout";
export default {
  computed: {
    ...mapGetters("auth/login", [
      "getInProgress",
      "getSuccess",
      "getErrorMessages",
    ]),
    userId() {
      return this.$root.userId;
    },
    errors() {
      let errorText = "";
      if (this.getErrorMessages.length == 0) {
        return null;
      } else {
        for (const error of this.getErrorMessages) {
          errorText += error;
        }
      }
      return errorText;
    },
  },
  created() {
    this.MAX_PASSWORD_LENGTH = MAX_PASSWORD_LENGTH;
  },
  methods: {
    loginAction() {
      this.logIn({
        username: this.username,
        password: this.password,
        redirect: this.$route.query.redirect,
      });
    },
    ...mapActions("auth/login", ["logIn"]),
    logout() {
      logout();
    },
  },
  watch: {
    getSuccess(newValue) {
      if (newValue == true) {
        this.username = "";
        this.password = "";
      }
    },
  },
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
      rules: {
        required: (value) => !!value || this.$t("forms.thisFieldIsRequired"),
      },
    };
  },
};
</script>
<style scoped>
.error-append {
  width: 2em;
  position: absolute;
  padding-left: 8px;
}
::v-deep .v-input__append-outer {
  margin-left: 0px !important;
  margin-right: 0 !important;
}
</style>